<template>
  <div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="modal-form-crear-planilla"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Planilla Vehículos</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <table
                  class="
                    table table-bordered table-striped table-hover table-sm
                  "
                >
                  <thead>
                    <tr>
                      <th>Vehículo</th>
                      <th>#Servicio</th>
                      <th>Fechas</th>
                      <th>Responsable</th>
                      <th>Verificación</th>
                      <th class="text-center" colspan="2">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(liqui, index) in detalleLiqui" :key="index">
                      <td class="text-center">
                        {{
                          liqui.tep_preliquidacion_nacional.tep_viaje.vehiculo
                            ? liqui.tep_preliquidacion_nacional.tep_viaje
                                .vehiculo.placa
                            : ""
                        }}
                      </td>
                      <td>
                        {{ liqui.tep_preliquidacion_nacional.tep_viaje_id }}
                      </td>
                      <td>
                        {{
                          liqui.tep_preliquidacion_nacional.tep_viaje.fecha_ini
                        }}
                        -
                        {{
                          liqui.tep_preliquidacion_nacional.tep_viaje.fecha_fin
                        }}
                      </td>
                      <td>
                        {{
                          liqui.tep_preliquidacion_nacional.tep_viaje.user
                            ? liqui.tep_preliquidacion_nacional.tep_viaje.user
                                .name
                            : ""
                        }}
                      </td>
                      <td class="text-center">
                        <input
                          v-if="
                            $store.getters.can(
                              'tep.liquidacionesNacionales.verificacion'
                            ) && liqui.planilla !== null
                          "
                          type="checkbox"
                          @change="cambiarCheck(liqui.planilla)"
                          :disabled="
                            liqui.planilla.verificado ||
                              liqui.planilla.verificado == 1
                          "
                          v-model="liqui.planilla.verificado"
                        />
                      </td>
                      <td class="text-center" v-if="liqui.planilla == null">
                        <button
                          type="button"
                          class="btn bg-indigo btn-sm"
                          v-if="liqui.planilla == null"
                          @click="upload(liqui.id)"
                        >
                          <i class="fas fa-upload"></i>
                        </button>
                      </td>
                      <td class="text-center col-sm-2">
                        <div v-if="fileDoc && flag === liqui.id">
                          <button
                            type="button"
                            class="btn btn-sm bg-warning"
                            @click="deletDoc()"
                          >
                            <i class="fas fa-trash-alt"></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-sm bg-success"
                            @click="subirDoc(liqui)"
                          >
                            <i class="fas fa-upload"></i>
                          </button>
                        </div>
                        <div v-else>
                          <div v-if="flag === liqui.id">
                            <input
                              type="file"
                              class="form-control-file"
                              ref="file"
                              id="btnFile"
                              @change="getFile"
                              accept="application/msword,application/pdf,application/rtf,image/*"
                            />
                          </div>
                        </div>
                        <button
                          type="button"
                          v-if="liqui.planilla"
                          class="btn btn-success btn-sm"
                          @click="
                            downloadPlanilla(liqui.planilla.link_planilla)
                          "
                        >
                          <i class="fas fa-download"></i>
                        </button>
                        <button
                          type="button"
                          v-if="liqui.planilla"
                          :disabled="
                            liqui.planilla.verificado == '1' ||
                              liqui.planilla.verificado == true
                          "
                          class="btn btn-danger btn-sm"
                          @click="deletBd(liqui)"
                        >
                          <i class="fas fa-trash-alt"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer"></div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "TepLiquidacionPlanilla",
  components: {},
  data() {
    return {
      flag: null,
      form: {
        vehiculo_id: null,
        fecha_inicial: null,
        hora_inicial: null,
      },
      detalleLiqui: {},
      liquidacion: {},
      padre: {},
      fileDoc: null,
      tipo_control: null,
      uri_docs: process.env.VUE_APP_AWS_BUCKET_URL,
    };
  },
  methods: {
    async llenar_modal(item) {
      this.$parent.cargando = true;
      this.liquidacion = item;
      await axios
        .get("/api/tep/liquidacionesNacionales/showDetallePlanilla", {
          params: {
            liqui_id: item.id,
          },
        })
        .then((response) => {
          this.$parent.cargando = false;
          this.detalleLiqui = response.data;
        });
    },

    upload(item) {
      this.fileDoc = null;
      this.flag = item;
    },

    getFile(e) {
      if (e.target.files[0]) {
        const file = e.target.files[0];
        if (this.validaArchivo(file)) {
          this.fileDoc = file;
        }
      }
    },

    validaArchivo(file) {
      let flag = true;
      if (file.size > 2048000) {
        flag = false;
        let inputImage = document.getElementById("btnFile");
        inputImage.value = "";
        this.$swal({
          icon: "error",
          title: `El Archivo es muy pesado para subirlo`,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
      return flag;
    },

    deletDoc() {
      this.fileDoc = null;
    },

    subirDoc(liqui) {
      this.$parent.cargando = true;
      let formData = new FormData();
      formData.append(
        "tep_liquidacion_nacional_id",
        liqui.tep_liquidacion_nacional_id
      );
      formData.append(
        "tep_viaje_id",
        liqui.tep_preliquidacion_nacional.tep_viaje_id
      );
      formData.append("link_planilla", this.fileDoc);
      axios
        .post("api/tep/liquidacionesNacionales/subirPlanilla", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Los datos se guardaron exitosamente...",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.llenar_modal(this.liquidacion);
          this.fileDoc = null;
          this.flag = null;
          this.$parent.cargando = false;
        })
        .catch(function(error) {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    downloadPlanilla(planilla) {
      window.open(this.uri_docs + planilla, "_blank");
    },

    deletBd(liqui) {
      this.$parent.cargando = true;
      axios
        .delete("/api/tep/liquidacionesNacionales/destroyPlanilla", {
          params: {
            id: liqui.planilla.id,
          },
        })
        .then(() => {
          this.$swal({
            icon: "success",
            title: "la planilla se eliminó correctamente...",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.llenar_modal(this.liquidacion);
          this.fileDoc = null;
          this.flag = null;
          this.$parent.cargando = false;
        })
        .catch(function(error) {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    cambiarCheck(planilla) {
      axios
        .post("/api/tep/liquidacionesNacionales/verificarDocumento", {
          planilla,
        })
        .then(() => {
          this.$parent.getIndex();
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error, vualeva a intentarlo..." + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.$parent.cargando = true;
        });
    },
  },
};
</script>
